<template>
	<BaseBanner :condition="blacklistedProducts.length > 0">
		<div class="blacklist__content">
			<p>
				Apologies, the following products have been blocked from being
				imported into {{ countryLabel }}:
			</p>

			<ul class="blacklist__list">
				<li v-for="product in blacklistedProducts" :key="product.sku">
					{{ product.name }}
				</li>
			</ul>

			<p>
				In order to complete your purchase, please remove these products
				from your cart and checkout.
			</p>
		</div>
	</BaseBanner>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseBanner from './index.vue';

export default {
	components: { BaseBanner },
	computed: {
		...mapGetters('checkout', ['blacklistedProducts', 'shippingCountry']),
		countryLabel() {
			return this.shippingCountry === 'USA'
				? 'United States of America'
				: 'Canada';
		},
	},
};
</script>
